import Modal from '@components/application/modal';
import DisclaimerModal from './disclaimerModal';

const DisclaimerWrapper = () => {
  return (
    <Modal hideClose id="disclaimerModal">
      <DisclaimerModal />
    </Modal>
  );
};

export default DisclaimerWrapper;
